import {useState} from 'react';


const DropDownBtnController = (setApproved, imageIndex, removeChosenClass) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(!open);
    };

    const handleChoseClass = (curClass) => {
        setApproved(imageIndex, curClass);
        setAnchorEl(null);
        setOpen(false);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
        setOpen(false);
    };

    const handleRemoveClass = () => {
        removeChosenClass(imageIndex);
    };


    return {handleOpenMenu, open, anchorEl, handleCloseMenu, handleChoseClass, handleRemoveClass};

};

export default DropDownBtnController;
